import { render, staticRenderFns } from "./ImageCtaLarge.vue?vue&type=template&id=efdcbb02&scoped=true&"
import script from "./ImageCtaLarge.vue?vue&type=script&lang=js&"
export * from "./ImageCtaLarge.vue?vue&type=script&lang=js&"
import style0 from "./ImageCtaLarge.vue?vue&type=style&index=0&id=efdcbb02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdcbb02",
  null
  
)

export default component.exports